import { render } from "./BatchShow.vue?vue&type=template&id=1d6c7004&scoped=true"
import script from "./BatchShow.vue?vue&type=script&lang=js"
export * from "./BatchShow.vue?vue&type=script&lang=js"

import "./BatchShow.vue?vue&type=style&index=0&id=1d6c7004&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6c7004"]])

export default __exports__